import React from 'react'
import { mapDeepErrors, mapError } from './utils'
import styles from './styles'

const ErrorFeedback = ({ errors }) => {
  let _errors = errors

  if (typeof errors === 'string') {
    _errors = {
      mensaje: errors
    }
  }

  const { errorCodes, ...rest } = _errors

  const errorsMapped = mapDeepErrors(rest)

  if (errorsMapped.length === 0) {
    return null
  }

  return (
    <details className="error-feedback-wrapper margin-top-one-rem">
      <summary>Ver los detalles del error</summary>
      {errorsMapped.map(mapError)}
      <style jsx>{styles}</style>
    </details>
  )
}

export default ErrorFeedback
